import { useLocale } from './useLocale';

export function useLanguage() {
  const locale = useLocale();

  return locale.slice(0, 2);
}
